












import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {Pages} from "@/class/pages";

@Component
export default class Navbar extends Vue {
  @Prop()
  private pages!: Pages;

  private page = 0;

  @Emit('choose-page')
  choosePage(page: number) {
    this.page = page;
    return page;
  }
}
